module.exports = "/_next/static/images/flip-shadow-f4d9bbce17fc8c6704c81f4193e03199.png";